import React from 'react';
import {OutlineMessageIcon} from 'common/icons';
import {Panel} from 'pages/user/components';
import {useSignInState, useUpdateSignInState} from 'state/sign-in';

import styles from './email-notification.module.scss';

export const EmailNotification = () => {
    const {username} = useSignInState();
    const {backToSignIn} = useUpdateSignInState();

    return (
        <Panel className={styles.container}>
            <OutlineMessageIcon size={80}/>
            <h2>Revise su correo electrónico</h2>
            <div className="flex flex-col gap-3 px-3">
                <p>Hemos enviado a <span className="underline">{username}</span> un enlace para acceder.</p>
                <span
                    className="text-xs px-2">Si el correo no está en su bandeja de entrada verifique la carpeta SPAM.</span>
            </div>
            <div className="pt-3">
                <h3>¿Se ha equivocado?</h3>
                <h3
                    className="underline pt-1 cursor-pointer"
                    onClick={backToSignIn}>
                    Vuelva a ingresar su correo electrónico
                </h3>
            </div>
        </Panel>
    );
};
